module.exports = __webpack_public_path__ + "static/media/write-fest-boomer.088678e1.png";